import { useRequest } from 'features/request/useRequest';

import { useMemo } from 'react';

import { gqlWorkOrderVersionSeasons } from '../workOrderVersionQueries';

export const useWorkOrderVersionSeasons = (workOrderVersionId: number, withEffect = true) => {
    const variables = useMemo(() => ({ workOrderVersionId }), [workOrderVersionId]);

    const [seasonsResponse, seasonsResponseStatus, seasonsResponseError] = useRequest({
        requestId: 'workOrderSeasons',
        query: gqlWorkOrderVersionSeasons,
        variables,
        withEffect,
    });

    return [seasonsResponse?.uerWorkOrderVersionSeasons ?? [], seasonsResponseStatus, seasonsResponseError];
};
